import React from 'react'
import { useFormatMessage } from '../../utils'
import styles from './styles.module.less'

export const AppFooter = () => {
  const formatMessage = useFormatMessage()

  return (
    <footer className={styles.footer}>
      <div className={styles.topSection}>
        <div>
          <p>
            FINRA BrokerCheck reports for Apex Clearing are available at{' '}
            <a href="http://www.finra.org/brokercheck" target="_blank" rel="noopener noreferrer">
              http://www.finra.org/brokercheck
            </a>
          </p>
          <p className={styles.footerLinks}>
            <a ng-href="https://www.apexclearing.com/privacy-policy" href="https://www.apexclearing.com/privacy-policy">
              Privacy Policy
            </a>
            <a ng-href="https://www.apexclearing.com/disclosures" href="https://www.apexclearing.com/disclosures">
              Business Continuity Plan and Other Disclosures
            </a>
            <a
              ng-href="https://www.apexclearing.com/futures-disclosures"
              href="https://www.apexclearing.com/futures-disclosures"
            >
              Futures Disclosures
            </a>
            <a ng-href="https://www.apexclearing.com/press" href="https://www.apexclearing.com/press">
              Press
            </a>
          </p>
        </div>
      </div>
      <div className={styles.footerCopyright}>
        <div className={`test-id-copyright ${styles.copyright}`}>
          <span>{`${formatMessage('common.copyrightSymbol')} ${new Date().getFullYear()} ${formatMessage(
            'common.apexClearingCorp'
          )}`}</span>
        </div>
        <div>
          {formatMessage('common.footer.member')} |{' '}
          <span className="app-version">ver {process.env.REACT_APP_VERSION}</span>
        </div>
      </div>
    </footer>
  )
}
